const BusinessPage = {
    accountCreated: "/registration/confirmation",
    accountLinkUp: "/sign/up/link",
    accountNotFound: "/registration/account-not-found",
    accountWaitingApproval: "/registration/waiting-approval",
    campaignSignIn: "/registration/campaign-sign-in",
    chooseCompany: "/select",
    dashboard: "/dashboard",
    inbox: "/inbox",
    inboxMessage: "/inbox/message/:id",
    payment: "/payment",
    setName: "/account/set-name",
    signIn: "/sign/in",
    signOut: "/sign/out",
    statementsAndInvoices: "/statements-and-invoices",
    subscriptions: "/subscriptions",
    support: "/support",
    updateProfile: "/account/manage-profile",
    userActivityLogging: "/users/logging",
    userInvites: "/users/invites",
    users: "/users"
}

export default BusinessPage;